import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from 'react-intl';
import utils from "../../utils/utils";

const PackerRefundCalculatorItem = ({orderItem, onRefundAmountChange}) => {
  const [resultPrice, setResultPrice] = useState("");

  const onWeightChange = newValue => {
    if (!orderItem.item.priceFields.unitPrice || !newValue || isNaN(newValue)) {
      setResultPrice(0);
      onRefundAmountChange(0);
      return;
    }

    const newValueNumber = Number(newValue);

    const newPrice = newValueNumber * orderItem.item.priceFields.unitPrice;
    const newRefundAmount = utils.getRoundedPrice(newPrice < orderItem.itemPrice? orderItem.itemPrice - newPrice: 0);
    setResultPrice(newRefundAmount);
    onRefundAmountChange(newRefundAmount);
  };

  const onRefundChange = newValue => {
    if (!newValue || !utils.isNumeric(newValue)) {
      setResultPrice(newValue);
      onRefundAmountChange(0);
      return;
    }

    const newValueNumber = utils.getRoundedPrice(Number(newValue));
    if (newValueNumber > orderItem.itemPrice) {
      setResultPrice("0");
      onRefundAmountChange(0);
      return;
    }

    setResultPrice(newValueNumber.toString());
    onRefundAmountChange(newValueNumber);
  };

  return (
    <tr>
      <td>
        <div>
          <strong>
            {orderItem.itemName}
          </strong>
        </div>
        <div>
          <small>
            <FormattedMessage id={'packer.refund.calculator.item.customer.price'}/>: {orderItem.itemPrice}€
          </small>
        </div>
        {
          orderItem.item.priceFields.unitPrice? (
            <>
              <div>
                <small>
                  <FormattedMessage id={'packer.refund.calculator.item.unit.price'}/>: {orderItem.item.priceFields.unitPrice}€
                </small>
              </div>
            </>
          ): ''
        }
      </td>
      <td>
        <input className="form-control" type="number" onChange={(event) => onWeightChange(event.target.value)}/>
      </td>
      <td>
        <input className="form-control" type="number" onChange={(event) => onRefundChange(event.target.value)}
               value={resultPrice}/>
      </td>
    </tr>
  );
}

PackerRefundCalculatorItem.propTypes = {
  orderItem: PropTypes.object.isRequired,
  onRefundAmountChange: PropTypes.func.isRequired,
};

PackerRefundCalculatorItem.defaultProps = {};

export default injectIntl(PackerRefundCalculatorItem);